import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { QRCodeCanvas } from 'qrcode.react';  // Import QRCodeCanvas
import { FaLinkedin, FaTwitter, FaInstagram, FaFacebook, FaYoutube, FaGlobe, FaPhoneAlt, FaEnvelope, FaTint, FaCalendarAlt, FaWhatsapp, FaMapMarkerAlt, FaPhotoVideo, FaDownload, FaShareAlt, FaAddressBook, FaEdit, FaStar } from 'react-icons/fa';  // Social media icons
import { FaMobileAlt, FaHome } from "react-icons/fa";
import html2canvas from "html2canvas";
import { useRef } from "react";
import { MdLocalOffer } from "react-icons/md";
import ReactPlayer from 'react-player';


const BLOOD_GROUPS = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];

const CardUrl = () => {
    const { code } = useParams();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);

    const [step, setStep] = useState(1);
    const [mobileInput, setMobileInput] = useState("");
    const [form, setForm] = useState({});
    const cardRef = useRef(null);

    useEffect(() => {
        setStep(1);
        fetch(`https://taaiappapi.emedha.in/pages/api/agencymembers/card/${code}`)
            .then((res) => (res.ok ? res.json() : null))
            .then((result) => {
                setData(result);
                console.log(result)
                // pick active rep
                const activeRep =
                    result.active_rep_code === result.rep1.card_URL ? result.rep1 : result.rep2;

                // merge active rep fields + root-level URLs
                setForm({
                    acc_rep1_name: activeRep.name || "",
                    acc_rep1_designation: activeRep.designation || "",
                    acc_rep1_mobile: activeRep.mobile || "",
                    acc_rep1_email: activeRep.email || "",
                    acc_rep1_passport_photo: activeRep.passport_photo || "",
                    acc_rep1_blood_group: activeRep.blood_group || "",
                    acc_rep1_dob: activeRep.dob ? activeRep.dob.split("T")[0] : "",
                    website: result.website || "",
                    facebook: result.facebook || "",
                    instagram: result.instagram || "",
                    linkedin: result.linkedin || "",
                    twitter: result.twitter || "",
                    video_url1: result.video_url1 || "",
                    video_url2: result.video_url2 || "",
                    video_url3: result.video_url3 || "",
                    video_url4: result.video_url4 || "",
                    testimonials: result.testimonials || "",
                    additional_images1: result.additional_images1 || "",
                    additional_images2: result.additional_images2 || "",
                    additional_images3: result.additional_images3 || "",
                    additional_images4: result.additional_images4 || "",
                    additional_images5: result.additional_images5 || "",
                });
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [code]);



    const [modalOpenPhotos, setModalOpenPhotos] = useState(false);
    const [modalOpenVideos, setModalOpenVideos] = useState(false);

    function cleanYouTubeUrl(url) {
        if (!url) return null;

        // Remove query params
        let cleanUrl = url.split("?")[0];

        // Convert youtu.be short URLs to youtube.com/watch?v=...
        if (cleanUrl.includes("youtu.be/")) {
            const videoId = cleanUrl.split("youtu.be/")[1];
            if (videoId) return `https://www.youtube.com/watch?v=${videoId}`;
            return null;
        }

        // Normal youtube.com URLs
        if (cleanUrl.includes("youtube.com/watch")) {
            const params = new URL(cleanUrl).searchParams;
            const videoId = params.get("v");
            if (videoId) return `https://www.youtube.com/watch?v=${videoId}`;
            return null;
        }

        return cleanUrl;
    }





    const [isMobile, setIsMobile] = useState(false);

    // Detect screen size
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768); // Mobile breakpoint <768px
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    const [otpInput, setOtpInput] = useState("");
    const [otpSent, setOtpSent] = useState(false);



    const handleSaveContact = () => {
        const vCard =
            "BEGIN:VCARD\r\n" +
            "VERSION:3.0\r\n" +
            `N:${activeRep.name};${activeRep.name};;;\r\n` +
            `FN:${activeRep.name}\r\n` +
            `ORG:${data.agency_name}\r\n` +
            `TITLE:${activeRep.designation}\r\n` +
            `TEL;TYPE=CELL:${activeRep.mobile}\r\n` +
            (activeRep.email ? `EMAIL:${activeRep.email}\r\n` : "") +
            (activeRep.blood_group ? `NOTE:Blood Group - ${activeRep.blood_group}\r\n` : "") +
            "END:VCARD\r\n";

        const blob = new Blob([vCard], { type: "text/x-vcard;charset=utf-8" });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${activeRep.name}.vcf`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };



    const handleDownload = async () => {
        if (!cardRef.current) return;

        const canvas = await html2canvas(cardRef.current, {
            scale: 2, // HD quality
            useCORS: true,
        });

        const image = canvas.toDataURL("image/png");

        const link = document.createElement("a");
        link.href = image;
        link.download = `${data.agency_name}_card.png`;
        link.click();
    };


    const handleShare = async () => {
        if (!cardRef.current) {
            alert("Card not found");
            return;
        }
        try {
            const canvas = await html2canvas(cardRef.current, {
                scale: 2,
                useCORS: true,
                backgroundColor: null,
                scrollY: -window.scrollY,
            });
            const blob = await new Promise((resolve) =>
                canvas.toBlob(resolve, "image/png", 1)
            );
            if (!blob) {
                alert("Image capture failed");
                return;
            }
            const file = new File([blob], "agency-card.png", {
                type: "image/png",
            });
            if (!navigator.canShare || !navigator.canShare({ files: [file] })) {
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "agency-card.png";
                a.click();
                URL.revokeObjectURL(url);
                alert("Sharing not supported. Image downloaded instead.");
                return;
            }
            await navigator.share({
                title: data.agency_name,
                text: "My Digital Business Card",
                files: [file],
            });
        } catch (error) {
            console.error("Share failed:", error);
            alert("Sharing failed on this device");
        }
    };


    const [offersOpen, setOffersOpen] = useState(false);
    const [offers, setOffers] = useState([]);
    const [offersLoading, setOffersLoading] = useState(false);

    const handleOpenOffers = async () => {
        setOffersOpen(true);
        setOffersLoading(true);

        try {
            const res = await fetch("https://taaiappapi.emedha.in/pages/api/get/offers"
            );
            const result = await res.json();
            setOffers(result || []);
        } catch (err) {
            console.error("Offers fetch error", err);
        } finally {
            setOffersLoading(false);
        }
    };



    if (loading)
        return (
            <p style={{ textAlign: "center", marginTop: 50, fontSize: 18, color: "#0258a1" }}>
                Loading card...
            </p>
        );

    if (!data)
        return (
            <p style={{ textAlign: "center", marginTop: 50, fontSize: 18, color: "#a00109" }}>
                Invalid card URL
            </p>
        );


    const activeRep =
        data.active_rep_code === data.rep1.card_URL ? data.rep1 : data.rep2;




    // Determine active rep
    const activeRepCode = data.active_rep_code === data.rep1.card_URL ? "rep1" : "rep2";

    // ======== Handlers ========
    const handleMobileSubmit = async (e) => {
        e.preventDefault();

        if (mobileInput !== activeRep.mobile) {
            alert("The entered number does not match the representative's number.");
            return; // Stop execution if numbers don't match
        }

        try {
            const res = await fetch("https://taaiappapi.emedha.in/pages/api/api/send-otpp/whatsapp",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        whatsappNumber: activeRep.mobile, // ✅ IMPORTANT
                        rep: activeRepCode
                    })
                }
            );

            const result = await res.json();

            if (result.success) {
                alert("OTP sent to " + activeRep.name + "'s WhatsApp");
                setOtpSent(true);
            } else {
                alert(result.message || result.error);
            }
        } catch (err) {
            console.error(err);
            alert("Error sending OTP");
        }
    };


    const handleOtpSubmit = async (e) => {
        e.preventDefault();

        try {
            const res = await fetch("https://taaiappapi.emedha.in/pages/api/api/verify-otp",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        whatsappNumber: activeRep.mobile, // ✅
                        otpCode: otpInput,                // ✅
                        rep: activeRepCode                // ✅
                    })
                }
            );

            const result = await res.json();

            if (result.success) {
                alert("OTP verified! You can edit your info now.");
                setStep(3);

                // ✅ Store OTP verified in sessionStorage
                sessionStorage.setItem('otpVerified', 'true');
            }
            else {
                alert(result.message);
            }
        } catch (err) {
            console.error(err);
            alert("Error verifying OTP");
        }
    };




    const isLocked = form.is_active === 1;



    // ===== Text input change =====
    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    // ===== File input change =====
    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (files.length > 0) {
            setForm((prev) => ({
                ...prev,
                [`${name}_file`]: files[0], // store file object for submission
                [name]: URL.createObjectURL(files[0]), // store preview
            }));
        }
    };

    // ===== Submit form =====
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        const activeRepCode = data.active_rep_code === data.rep1.card_URL ? "rep1" : "rep2";
        const testimonialsFiles = form.testimonials_files || [];
        testimonialsFiles.forEach(file => {
            formData.append("testimonials", file);
        });
        formData.append("active_rep", activeRepCode);
        formData.append("membership_id", data.membership_id);
        Object.keys(form).forEach((key) => {
            if (!key.endsWith("_file")) {
                formData.append(key, form[key] || "");
            }
        });
        const passportFile =
            activeRepCode === "rep1" ? form.acc_rep1_passport_photo_file : form.acc_rep2_passport_photo_file;
        if (passportFile) formData.append("passport_photo", passportFile);
        for (let i = 1; i <= 5; i++) {
            const file = form[`additional_images${i}_file`];
            if (file) formData.append(`additional_image${i}`, file);
        }
        try {
            const res = await fetch("https://taaiappapi.emedha.in/pages/api/agencymembers/update", {
                method: "PUT",
                body: formData,
            });
            const result = await res.json();
            console.log("Response:", result);
            alert("Form submitted successfully!");
            setStep(1);
        } catch (err) {
            console.error(err);
            alert("Error submitting form!");
        }
    };


    if (step === 1) {
        const activeRep = data.active_rep_code === data.rep1.card_URL ? data.rep1 : data.rep2;
        const personalMobile = activeRep?.mobile || "";
        const phoneLink = `tel:${personalMobile}`;
        const whatsappLink = `https://wa.me/${personalMobile.replace(/\D/g, "")}`;

        const locationLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
            `${data.address}, ${data.city}, ${data.state}, ${data.country}`
        )}`;

        return (
            <div ref={cardRef} style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", maxWidth: 900, margin: "1px auto", padding: 30, background: "linear-gradient(135deg, #f7e7a9, #f1dc8d)", boxShadow: "0 20px 50px rgba(0,0,0,0.15)", color: "#000", }}>
                {/* ================= COMPANY SECTION ================= */}
                <header style={{ marginBottom: 40, paddingBottom: 24, borderBottom: "1px solid rgba(2,88,161,0.3)", position: "relative", paddingTop: 45, }}>
                    {/* Top Right Icons */}
                    <div style={{ position: "absolute", top: 0, right: 0, display: "flex", gap: 12, }}>
                        <button onClick={() => { setStep(2); sessionStorage.setItem('cardStep', 2); }} title="Edit" style={{ background: "#4caf50", color: "#fff", border: "none", borderRadius: "50%", width: 40, height: 40, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", }}><FaEdit />  </button>
                        <button onClick={handleSaveContact} title="Save Contact" style={{ background: "#ff9800", color: "#fff", border: "none", borderRadius: "50%", width: 40, height: 40, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", }}><FaAddressBook /> </button>
                        <button onClick={handleDownload} title="Download" style={{ background: "#0258a1", color: "#fff", border: "none", borderRadius: "50%", width: 40, height: 40, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", }}><FaDownload /></button>
                        <button onClick={handleShare} title="Share" style={{ background: "#7a0f16", color: "#fff", border: "none", borderRadius: "50%", width: 40, height: 40, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", }}><FaShareAlt /></button>
                    </div>

                    {/* ================= REPRESENTATIVE SECTION ================= */}
                    <section style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "auto 150px", gap: 30, alignItems: "center", padding: 30, borderRadius: 16, backgroundColor: "#ffffff", boxShadow: "0 12px 30px rgba(0,0,0,0.12)", }}>
                        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "150px auto", gap: 24, alignItems: "center", textAlign: isMobile ? "center" : "left", }}><img src={activeRep.passport_photo} alt={activeRep.name} style={{ width: 150, height: 190, objectFit: "cover", borderRadius: 12, border: "4px solid #0258a1", boxShadow: "0 6px 16px rgba(0,0,0,0.2)", justifySelf: isMobile ? "center" : "start", }} /><div>
                            <h2 style={{ margin: 0, fontSize: 28, fontWeight: 700, color: "#0258a1", textTransform: "uppercase" }}>{activeRep.name}</h2>
                            <p style={{ marginTop: 6, fontSize: 17, fontWeight: 600, color: "#a00109" }}>{activeRep.designation}</p>
                            <p style={{ fontSize: 17, marginTop: 14, lineHeight: 1.6 }}>
                                <FaPhoneAlt style={{ marginRight: "8px", color: "#0258a1" }} />
                                {activeRep.mobile}
                                <br />
                                <FaEnvelope style={{ marginRight: "8px", color: "#0258a1" }} />
                                <a href={`mailto:${activeRep.email}`} style={{ color: "#0258a1", textDecoration: "none" }}>{activeRep.email}</a>
                            </p>
                            <p style={{ fontSize: 16, marginTop: 10 }}><FaTint style={{ marginRight: "8px", color: "#0258a1" }} />{activeRep.blood_group}</p>
                            <p style={{ fontSize: 16 }}>
                                <FaCalendarAlt style={{ marginRight: "8px", color: "#0258a1" }} />
                                {activeRep.dob ? activeRep.dob.split("T")[0] : ""}
                            </p>
                        </div>
                        </div>
                        <QRCodeCanvas value={`https://taaiapp.emedha.in/cardurl/${code}`} size={150} bgColor="#f6ebbf" fgColor="#0258a1" style={{ padding: 10, background: "#fff", borderRadius: 12, boxShadow: "0 8px 20px rgba(0,0,0,0.15)", justifySelf: isMobile ? "center" : "end", marginTop: isMobile ? 20 : 0, }} />
                    </section>

                    <div>
                        <h1 style={{ margin: 0, fontSize: 38, fontWeight: 800, letterSpacing: 1.2, color: "#0258a1", }}>{data.agency_name}</h1>
                        <div style={{ marginTop: 8, fontSize: 15, fontWeight: 600, color: "#7a0f16", display: "flex", flexDirection: "column", gap: 4, }}>
                            <span>CATEGORY: {data.category}</span>
                            <span>MEMBERSHIP ID: {data.membership_id}</span>
                            <span>JOINED: {data.year_of_joining}</span>
                        </div>
                        <p style={{ marginTop: 14, fontSize: 16, lineHeight: 1.6, display: "flex", alignItems: "flex-start", gap: 6, flexWrap: "wrap", }}>
                            <FaHome color="#0258a1" />
                            {data.address}, {data.city}, {data.state}, {data.country} -{" "}
                            {data.pin_code}
                        </p>
                        <div style={{ marginTop: 8, fontSize: 16, display: "flex", flexWrap: "wrap", gap: 20, }}>
                            <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                <FaPhoneAlt />{data.telephone || "-"}
                            </span>
                            <a href={`tel:${data.mobile}`} style={{ display: "flex", alignItems: "center", gap: 6, color: "#0258a1", textDecoration: "none", fontWeight: 600, }}>
                                <FaMobileAlt />{data.mobile}
                            </a>
                        </div>
                        <p style={{ marginTop: 8, fontSize: 16, display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap", }}>
                            <FaEnvelope /><a href={`mailto:${data.email}`} style={{ color: "#0258a1", textDecoration: "none" }}>{data.email}</a>
                        </p>
                        <p style={{ marginTop: 8, fontSize: 16, display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap", }}>
                            <FaGlobe /><a href={data.website} target="_blank" rel="noreferrer" style={{ color: "#0258a1", textDecoration: "none", wordBreak: "break-all", }}>{data.website}</a>
                        </p>
                        <p style={{ marginTop: 16, fontSize: 16, fontStyle: "italic" }}>
                            Activities: {data.other_activity}
                        </p>
                    </div>

                    <button onClick={handleOpenOffers} style={{ color: "#fff", background: "linear-gradient(135deg, #ff9800, #ff5722)", padding: "10px 20px", borderRadius: 30, border: "none", cursor: "pointer", boxShadow: "0 6px 14px rgba(0,0,0,0.25)", width: "100%", height: 46, display: "flex", alignItems: "center", justifyContent: "center", gap: 8, }}>
                        <MdLocalOffer size={18} />Offers
                    </button>

                    {/* ================= ACCESS US ================= */}
                    <div style={{ backgroundColor: "#ffffff", padding: 20, marginTop: 24, borderRadius: 16, boxShadow: "0 10px 24px rgba(0,0,0,0.12)", }}>
                        <h3 style={{ marginTop: 0, color: "#0258a1", display: "flex", alignItems: "center", fontSize: "24px", fontWeight: "bold", textTransform: "uppercase", }}>
                            <FaGlobe style={{ marginRight: 8 }} /> Access Us
                        </h3>
                        <div style={{ marginTop: 16, display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 16, }}>
                            <a href={locationLink} target="_blank" rel="noopener noreferrer" style={{ backgroundColor: "#f39c12", color: "#fff", padding: "10px 20px", borderRadius: 30, textDecoration: "none", boxShadow: "0 6px 14px rgba(0,0,0,0.2)", height: 46, display: "flex", alignItems: "center", justifyContent: "center", gap: 6, fontWeight: 600, }}>
                                <FaMapMarkerAlt /> Location
                            </a>
                            <button onClick={() => setModalOpenPhotos(true)} style={{ backgroundColor: "#7a0f16", color: "#fff", padding: "10px 20px", borderRadius: 30, border: "none", cursor: "pointer", boxShadow: "0 6px 14px rgba(0,0,0,0.2)", height: 46, display: "flex", alignItems: "center", justifyContent: "center", gap: 6, fontWeight: 600, }}>
                                <FaPhotoVideo /> My Gallery
                            </button>
                            <button onClick={() => window.open(data.testimonials, "_blank")} style={{ background: "linear-gradient(135deg, #16a085, #1abc9c)", color: "#fff", padding: "10px 20px", borderRadius: 30, border: "none", cursor: "pointer", boxShadow: "0 6px 14px rgba(0,0,0,0.2)", height: 46, display: "flex", alignItems: "center", justifyContent: "center", gap: 6, fontWeight: 600, }}>
                                <FaStar /> Testimonials
                            </button>
                            <button onClick={() => setModalOpenVideos(true)} style={{ backgroundColor: "#8e44ad", color: "#fff", padding: "10px 20px", borderRadius: 30, border: "none", cursor: "pointer", boxShadow: "0 6px 14px rgba(0,0,0,0.2)", height: 46, display: "flex", alignItems: "center", justifyContent: "center", gap: 6, fontWeight: 600, }}>
                                <FaPhotoVideo /> Videos
                            </button>
                            <a href={data.youtube} target="_blank" rel="noreferrer" style={{ background: "linear-gradient(135deg, #004182, #ff1a1a)", color: "#fff", padding: "10px 20px", borderRadius: 30, textDecoration: "none", boxShadow: "0 6px 14px rgba(0,0,0,0.2)", height: 46, display: "flex", alignItems: "center", justifyContent: "center", gap: 6, fontWeight: 600, }}>
                                <FaYoutube /> YouTube
                            </a>
                        </div>
                    </div>
                </header>



                {/* ================= SOCIAL MEDIA ================= */}
                <div style={{ backgroundColor: "#ffffff", padding: 20, marginTop: 24, borderRadius: 16, boxShadow: "0 10px 24px rgba(0,0,0,0.12)", }}>
                    <h3 style={{ marginTop: 0, color: "#0258a1", display: "flex", alignItems: "center", fontSize: "24px", fontWeight: "bold", textTransform: "uppercase", }}>
                        <FaGlobe style={{ marginRight: "8px" }} /> Let's Connect
                    </h3>
                    <div style={{ marginTop: 16, display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 16, flexWrap: "wrap", }}>
                        <a href={whatsappLink} target="_blank" rel="noopener noreferrer" style={{ backgroundColor: "#25D366", color: "#fff", padding: "10px 20px", borderRadius: 30, textDecoration: "none", boxShadow: "0 6px 14px rgba(0,0,0,0.2)", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, }}>
                            <FaWhatsapp /> WhatsApp
                        </a>
                        <a href={data.instagram} target="_blank" rel="noreferrer" style={{ color: "#fff", background: "linear-gradient(135deg, #0258a1, #d4145a)", padding: "10px 20px", borderRadius: 30, textDecoration: "none", boxShadow: "0 6px 14px rgba(0,0,0,0.2)", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, }}>
                            <FaInstagram /> Instagram
                        </a>
                        <a href={phoneLink} style={{ backgroundColor: "#0258a1", color: "#fff", padding: "10px 20px", borderRadius: 30, textDecoration: "none", boxShadow: "0 6px 14px rgba(0,0,0,0.2)", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, }}>
                            <FaMobileAlt /> Call
                        </a>
                        <a href={data.twitter} target="_blank" rel="noreferrer" style={{ color: "#fff", background: "linear-gradient(135deg, #1da1f2, #0077b5)", padding: "10px 20px", borderRadius: 30, textDecoration: "none", boxShadow: "0 6px 14px rgba(0,0,0,0.2)", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, }}>
                            <FaTwitter /> Twitter
                        </a>
                        <a href={data.facebook} target="_blank" rel="noreferrer" style={{ color: "#fff", background: "linear-gradient(135deg, #0258a1, #013d73)", padding: "10px 20px", borderRadius: 30, textDecoration: "none", boxShadow: "0 6px 14px rgba(0,0,0,0.2)", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, }}>
                            <FaFacebook /> Facebook
                        </a>
                        <a href={data.linkedin} target="_blank" rel="noreferrer" style={{ color: "#fff", background: "linear-gradient(135deg, #0a66c2, #004182)", padding: "10px 20px", borderRadius: 30, textDecoration: "none", boxShadow: "0 6px 14px rgba(0,0,0,0.2)", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, }}>
                            <FaLinkedin /> LinkedIn
                        </a>
                    </div>
                </div>

                {modalOpenPhotos && (
                    <div onClick={() => setModalOpenPhotos(false)} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                        <div onClick={(e) => e.stopPropagation()} style={{ backgroundColor: "#fff", padding: 20, borderRadius: 12, maxWidth: "90%", maxHeight: "90%", overflowY: "auto", }}>
                            <button onClick={() => setModalOpenPhotos(false)} style={{ float: "right", background: "#e74c3c", color: "#fff", border: "none", borderRadius: 6, padding: "4px 12px", cursor: "pointer", }}>Close</button>
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 12, marginTop: 20, }}>
                                {[
                                    form.additional_images1,
                                    form.additional_images2,
                                    form.additional_images3,
                                    form.additional_images4,
                                    form.additional_images5,
                                ].filter(Boolean).map((imgUrl, idx) => (<img key={idx} src={imgUrl} alt={`Image ${idx + 1}`} style={{ width: "100%", borderRadius: 8 }} />))}
                            </div>
                        </div>
                    </div>
                )}

                {/* VIDEOS MODAL */}
                {modalOpenVideos && (
                    <div onClick={() => setModalOpenVideos(false)} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                        <div onClick={(e) => e.stopPropagation()} style={{ backgroundColor: "#fff", padding: 20, borderRadius: 12, maxWidth: "90%", maxHeight: "90%", overflowY: "auto", }}>
                            <button onClick={() => setModalOpenVideos(false)} style={{ float: "right", background: "#e74c3c", color: "#fff", border: "none", borderRadius: 6, padding: "4px 12px", cursor: "pointer", }}>Close</button>
                            <div style={{ width: "300px", display: "grid", gap: 16, marginTop: 20, }}>
                                {[form.video_url1, form.video_url2, form.video_url3, form.video_url4]
                                    .filter(Boolean)
                                    .map((vidUrl, idx) => {
                                        const cleanUrl = cleanYouTubeUrl(vidUrl);
                                        if (!cleanUrl) return null;
                                        return (
                                            <div key={idx} style={{ position: "relative", paddingTop: "56.25%", borderRadius: 12, overflow: "hidden", boxShadow: "0 6px 16px rgba(0,0,0,0.15)", }}>
                                                <ReactPlayer url={cleanUrl} controls width="100%" height="100%" style={{ position: "absolute", top: 0, left: 0 }} />
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    </div>
                )}

                {offersOpen && (
                    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }} onClick={() => setOffersOpen(false)}>
                        <div onClick={(e) => e.stopPropagation()} style={{ background: "#fff", width: "90%", maxWidth: 600, maxHeight: "80vh", overflowY: "auto", borderRadius: 16, padding: 24, boxShadow: "0 20px 40px rgba(0,0,0,0.3)", }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20, }}>
                                <h2 style={{ margin: 0, color: "#0258a1" }}><MdLocalOffer /> Available Offers</h2>
                                <button onClick={() => setOffersOpen(false)} style={{ background: "transparent", border: "none", fontSize: 22, cursor: "pointer", }}>✕</button>
                            </div>
                            {offersLoading ? (
                                <p style={{ textAlign: "center" }}>Loading offers...</p>
                            ) : offers.length === 0 ? (
                                <p style={{ textAlign: "center" }}>No offers available</p>
                            ) : (
                                offers.map((offer) => (
                                    <div key={offer.id} style={{ display: "flex", gap: 16, padding: 16, borderRadius: 12, marginBottom: 16, background: "#f7f7f7", boxShadow: "0 6px 16px rgba(0,0,0,0.1)", }}>
                                        <img src={offer.image} alt={offer.title} style={{ width: 120, height: 90, objectFit: "cover", borderRadius: 10, }} />
                                        <div style={{ flex: 1 }}>
                                            <h3 style={{ margin: "0 0 6px", color: "#7a0f16" }}>{offer.title}</h3>
                                            <p style={{ margin: "4px 0", fontWeight: 600 }}>🔥 {offer.discount}% OFF</p>
                                            <p style={{ margin: "6px 0", fontSize: 14, background: "#0258a1", color: "#fff", display: "inline-block", padding: "4px 10px", borderRadius: 6, }}>Coupon: {offer.coupon}</p>
                                            <p style={{ marginTop: 6, fontSize: 13, color: "#555" }}>Valid till:{" "}{new Date(offer.expiry_date).toLocaleDateString()}</p>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                )}

            </div>

        );
    }

    if (step === 2) {
        return (
            <div style={{ maxWidth: 420, margin: "60px auto", padding: 30, borderRadius: 20, background: "linear-gradient(135deg, #ffffff, #f1f5ff)", boxShadow: "0 25px 60px rgba(0,0,0,0.18)", textAlign: "center", fontFamily: "system-ui, -apple-system, Segoe UI", }}>
                {/* Header */}
                <div style={{ width: 70, height: 70, margin: "0 auto 16px", borderRadius: "50%", background: "linear-gradient(135deg, #0258a1, #1e90ff)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 30, boxShadow: "0 10px 25px rgba(2,88,161,0.45)", }}>🔐</div>
                <h2 style={{ marginBottom: 8, color: "#0258a1", fontWeight: 700 }}>Mobile Verification</h2>
                <p style={{ fontSize: 14, color: "#555", marginBottom: 25 }}>
                    Verify <b>{activeRep.name}</b>'s registered mobile number to continue
                </p>
                {!otpSent ? (
                    <form onSubmit={handleMobileSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                        <input type="text" placeholder={`Enter ${activeRep.name}'s mobile`} value={mobileInput} onChange={(e) => setMobileInput(e.target.value)} style={{ padding: "14px 16px", borderRadius: 12, border: "1px solid #cbd5e1", fontSize: 16, outline: "none", boxShadow: "inset 0 2px 6px rgba(0,0,0,0.08)", }} />
                        <button type="submit" style={{ padding: "14px", borderRadius: 14, border: "none", fontSize: 16, fontWeight: 600, color: "#fff", background: "linear-gradient(135deg, #0258a1, #1e90ff)", cursor: "pointer", boxShadow: "0 12px 30px rgba(2,88,161,0.45)", transition: "transform 0.15s ease", }} onMouseDown={(e) => (e.currentTarget.style.transform = "scale(0.98)")} onMouseUp={(e) => (e.currentTarget.style.transform = "scale(1)")}>Send OTP</button>
                    </form>
                ) : (
                    <form onSubmit={handleOtpSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                        <input type="text" placeholder="Enter 6-digit OTP" value={otpInput} onChange={(e) => setOtpInput(e.target.value)} style={{ padding: "14px 16px", borderRadius: 12, border: "1px solid #cbd5e1", fontSize: 18, letterSpacing: 4, textAlign: "center", outline: "none", boxShadow: "inset 0 2px 6px rgba(0,0,0,0.08)", }} />
                        <button type="submit" style={{ padding: "14px", borderRadius: 14, border: "none", fontSize: 16, fontWeight: 600, color: "#fff", background: "linear-gradient(135deg, #16a34a, #22c55e)", cursor: "pointer", boxShadow: "0 12px 30px rgba(22,163,74,0.45)", }}>Verify OTP</button>
                    </form>
                )}
                {/* Footer */}
                <p style={{ marginTop: 20, fontSize: 12, color: "#888" }}>
                    OTP is sent securely to the registered number
                </p>
            </div>

        );
    }

    if (step === 3) {
        return (
            <div style={{ maxWidth: 700, margin: "30px auto", fontFamily: "system-ui", padding: "0 15px" }}>
                <h2 style={{ textAlign: "center", marginBottom: 20 }}>Edit Card Info</h2>
                <form onSubmit={handleFormSubmit} style={{ display: "flex", flexDirection: "column", gap: 15, background: "#ffffff", padding: 20, borderRadius: 12, boxShadow: "0 2px 8px rgba(0,0,0,0.1)", }}>
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        Name <input type="text" name="acc_rep1_name" value={form.acc_rep1_name || ""} onChange={handleFormChange} disabled={isLocked} style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }} />
                    </label>
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        Designation <input type="text" name="acc_rep1_designation" value={form.acc_rep1_designation || ""} onChange={handleFormChange} disabled={isLocked} style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }} />
                    </label>
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        Mobile <input type="text" name="acc_rep1_mobile" value={form.acc_rep1_mobile || ""} onChange={handleFormChange} disabled={isLocked} style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }} />
                    </label>
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        Email <input type="email" name="acc_rep1_email" value={form.acc_rep1_email || ""} onChange={handleFormChange} disabled={isLocked} style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }} />
                    </label>
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        Passport Photo <input type="file" name="acc_rep1_passport_photo" disabled={isLocked} onChange={(e) => { const file = e.target.files[0]; if (file) { setForm((prev) => ({ ...prev, acc_rep1_passport_photo_file: file })); setForm((prev) => ({ ...prev, acc_rep1_passport_photo: URL.createObjectURL(file), })); } }} style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }} />
                    </label>
                    {form.acc_rep1_passport_photo && (
                        <img src={form.acc_rep1_passport_photo} alt="rep" disabled={isLocked} style={{ width: "100%", maxWidth: 150, height: "auto", objectFit: "cover", marginTop: 8, borderRadius: 6, }} />
                    )}
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        Blood Group
                        <select name="acc_rep1_blood_group" value={form.acc_rep1_blood_group || ""} onChange={handleFormChange} disabled={isLocked} style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }}>
                            <option value="">Select</option>
                            {BLOOD_GROUPS.map((bg) => (<option key={bg} value={bg}>{bg}</option>))}
                        </select>
                    </label>
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        Date of Birth <input type="date" name="acc_rep1_dob" value={form.acc_rep1_dob || ""} onChange={handleFormChange} disabled={isLocked} style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }} />
                    </label>
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        Website <input type="text" name="website" value={form.website || ""} onChange={handleFormChange} placeholder="https://example.com" style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }} />
                    </label>
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        Facebook <input type="text" name="facebook" value={form.facebook || ""} onChange={handleFormChange} placeholder="https://facebook.com" style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }} />
                    </label>
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        Instagram <input type="text" name="instagram" value={form.instagram || ""} onChange={handleFormChange} placeholder="https://instagram.com" style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }} />
                    </label>
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        LinkedIn <input type="text" name="linkedin" value={form.linkedin || ""} onChange={handleFormChange} placeholder="https://linkedin.com" style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }} />
                    </label>
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        Twitter <input type="text" name="twitter" value={form.twitter || ""} onChange={handleFormChange} placeholder="https://twitter.com" style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }} />
                    </label>
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        Additional images 1 <input type="file" name="additional_images1" onChange={handleFileChange} style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }} />
                    </label>
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        Additional images 2 <input type="file" name="additional_images2" onChange={handleFileChange} style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }} />
                    </label>
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        Additional images 3 <input type="file" name="additional_images3" onChange={handleFileChange} style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }} />
                    </label>
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        Additional images 4 <input type="file" name="additional_images4" onChange={handleFileChange} style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }} />
                    </label>
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        Additional images 5 <input type="file" name="additional_images5" onChange={handleFileChange} style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }} />
                    </label>
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        Testimonials (PDF)
                        <input
                            type="file"
                            name="testimonials"
                            multiple
                            accept="application/pdf"
                            onChange={(e) => {
                                const files = Array.from(e.target.files);
                                setForm(prev => ({ ...prev, testimonials_files: files }));
                            }}
                            style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }}
                        />
                    </label>
                    {form.testimonials_files && form.testimonials_files.length > 0 && (
                        <div style={{ marginTop: 8 }}>
                            <strong>Selected PDFs:</strong>
                            <ul>
                                {form.testimonials_files.map((file, idx) => (
                                    <li key={idx}>
                                        <a href={URL.createObjectURL(file)} target="_blank" rel="noreferrer">{file.name}</a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        YouTube Url 1
                        <input type="text" name="video_url1" value={form.video_url1 || ""} onChange={handleFormChange} placeholder="https://youtube.com" style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }} />
                    </label>
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        YouTube Url 2
                        <input type="text" name="video_url2" value={form.video_url2 || ""} onChange={handleFormChange} placeholder="https://youtube.com" style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }} />
                    </label>
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        YouTube Url 3
                        <input type="text" name="video_url3" value={form.video_url3 || ""} onChange={handleFormChange} placeholder="https://youtube.com" style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }} />
                    </label>
                    <label style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
                        YouTube Url 4
                        <input type="text" name="video_url4" value={form.video_url4 || ""} onChange={handleFormChange} placeholder="https://youtube.com" style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", fontSize: 14 }} />
                    </label>
                    <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 10 }}>
                        <button type="submit" style={{ flex: 1, padding: 12, background: "#0258a1", color: "#fff", borderRadius: 6, border: "none", cursor: "pointer", }}>
                            Save Changes
                        </button>
                        <button type="button" onClick={() => setStep(1)} style={{ flex: 1, padding: 12, background: "#888", color: "#fff", borderRadius: 6, border: "none", cursor: "pointer", }}>
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        );
    }

    return null;
};

export default CardUrl;
